module.exports = __webpack_public_path__ + "site-build/img/banner.ed2b39b4.png";